import "./Es3Ticker.css";

const WORDS = ["painters", "potters", "poets", "photographers", "stitchers", "storytellers", "first-timers"];

function Es3Ticker() {
  const repeated = [...WORDS, ...WORDS];
  return (
    <div className="es3-ticker" aria-hidden="true">
      <div className="es3-ticker-track">
        {repeated.map((w, i) => (
          <span key={i}>{w}</span>
        ))}
      </div>
    </div>
  );
}

export default Es3Ticker;
